import executeRequest from "./request.js";
export const patch = async (url, data) => {
    const response = await executeRequest(url, "PATCH", data);
    return response;
};
